import React, { Component } from 'react'
import { AdminUsersSearchBarForm } from './AdminUsersSearchBarForm'
import { UserStatusEnum } from '@/enums';

interface IProps {
    searchTerm?: string;
    status?: UserStatusEnum | '*';
    onSearchChanged: (filter: AdminUsersSearch) => void;
}

export interface AdminUsersSearch {
    searchTerm?: string;
    status?: UserStatusEnum | '*';
}

export class AdminUsersSearchBar extends Component<IProps> {
    render() {
        return (
            <div className="w-full flex flex-col md:flex-row bg-gray-100 dark:bg-gray-800 tex-black dark:text-white rounded-sm px-6 py-2">
                <div className="flex-grow">
                    <h2 className="text-gpas-700 dark:text-white pb-1">Filtros de Usuarios</h2>
                    <p>Búsqueda de usuarios registrados </p>
                </div>
                <div className="flex flex-row items-center">
                    <AdminUsersSearchBarForm searchTerm={this.props.searchTerm} status={this.props.status} onSearchChanged={this.props.onSearchChanged} />
                </div>
            </div>
        )
    }
}
